import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import ModernDatepicker from 'react-modern-datepicker';
import { setTime, setTimeShow, setDate, setStep, handleStepBack, handleNextStep, setFNOLDetails, completeStep, checkDuplicateClaimDrivable, setStationary, setFnolIncidentEventList, checkDateTime, getDateString, setClaimData } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import TimeKeeper from 'react-timekeeper';
import '../../FNOL/FNOL.css'
import { showDuplicateClaim } from '../../../actions/modalActions';
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import { CLAIM_TYPE_GLASS } from '../../../constants/constants';
import { postToController } from '../../../actions/apiActions';
import { validateCellphoneNumber } from '../../../constants/validation';

class FnolStep1Sub4 extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            fnolStep: this.props.claimSubmit.selectedClaimStep.step,
            fnolSubStep: this.props.claimSubmit.selectedClaimStep.subStep,
            selectedCover: null,
            coverToggle: false,
            IncidentToggle: false,
            nextDisabled: true,
            Step1Submitted: false,
            causeOfCollision: this.props.claimSubmit.incidentEventType,
            hasCause: this.props.claimSubmit.incidentEventType !== "",
            hasDate: this.props.claimSubmit.incidentDate !== "",
            hasTime: this.props.claimSubmit.incidentTime !== "",
            hasTimeChanged: (this.props.claimSubmit.incidentTime != "") ? true : false,
            hasFutureDate: false,
            hasFutureTime: false,
            startDate: this.props.claimSubmit.incidentDate,
            contact: this.props.profile.cellphoneNumber,
            contactValidation: true,
            Step1Disabled: false,
            name: this.props.profile.name + " " + this.props.profile.surname,
            time24: "12:00",
            time12: "12:00 pm",
            maxDate: new Date(),
            mouseOut: false,
            isClosed: false,
        };
        this.handleIncidentEventSelection = this.handleIncidentEventSelection.bind(this);
        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        this.handleIndidentDateClicked = this.handleIndidentDateClicked.bind(this);
        this.handleIncidentToggle = this.handleIncidentToggle.bind(this);
        this.setTime = this.setTime.bind(this);
        this.handleStep1Submit = this.handleStep1Submit.bind(this);
        this.handleChangeStep1 = this.handleChangeStep1.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleIncidentSelection = this.handleIncidentSelection.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
        this.checkTimeToggle = this.checkTimeToggle.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.setMouseOut = this.setMouseOut.bind(this);
        this.setMouseIn = this.setMouseIn.bind(this);
        this.listenAwayClick = this.listenAwayClick.bind(this);
        this.handleIsStationary = this.handleIsStationary.bind(this);
        this.validateTime = this.validateTime.bind(this);
    }

    async setMouseOut() {
        await this.setState({ mouseOut: true });
        this.listenAwayClick();
    }

    async setMouseIn() {
        await this.setState({ mouseOut: false });
        this.listenAwayClick();
    }

    async handleClickAway() {
        if (!this.state.isClosed) {
            document.body.removeEventListener("click", this.handleClickAway);
        }
        if (this.state.hasTime) {
            this.setTime(this.state.time12, this.state.time24);
        }
        else {
            this.props.dispatchSetTimeShow();
        }
    }

    handleTimeChange(f12: any, f24: any) {
        this.setState({ hasTime:true, time12: f12, time24: f24 });
        this.props.dispatchSetTime(f12, f24);
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    async handleStepBack() {
        this.setState({ DescriptionWhatDisabled: false });
        if (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) {
            await this.props.dispatchSetStep(1, 1);
        }
        else {
            await this.props.dispatchSetStep(1, 2);
        }
    }

    async handleIncidentSelection(e: any) {
        let eventType = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ causeOfCollision: eventType[0], hasCause: true, });
    }

    handleChangeDateValue(date) {
        this.setState({
            startDate: date
        });
        this.props.dispatchSetDate(date);
        this.setState({ hasDate: true });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchSetTimeShow();
        }
    }

    listenAwayClick() {
        if (this.state.mouseOut && !this.state.isClosed) {
            document.body.addEventListener("click", this.handleClickAway);
        }
        else {
            document.body.removeEventListener("click", this.handleClickAway);
        }
    }

    handleChangeStep1(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    async validateTime() : Promise<any> {
        var dateString = getDateString(this.state.startDate, this.props.claimSubmit.time);
        var validation = await this.props.dispatchAction(checkDateTime(dateString));
        if (validation) {
            this.setState({
                hasFutureTime: validation.isFutureTime,
                hasFutureDate: validation.isFutureDate
            });
        }
        return validation;
    }

    async checkStep1Answers() {
        this.setState({ Step1Submitted: true })
        let dateValidation = await this.validateTime();
        
        if (this.state.hasCause && dateValidation && (this.state.hasDate && !dateValidation.isFutureDate) && (this.state.hasTimeChanged && !dateValidation.isFutureTime) && this.state.name && this.state.contact) {
            this.setState({ Step1Disabled: false })
        }
        else {
            this.setState({ Step1Disabled: true })
        }
    }

    async handleStep1Submit() {
        this.setState({ Step1Submitted: true })
        let dateValidation = await this.validateTime();

        this.setState({ contactValidation: validateCellphoneNumber.test(this.state.contact) });

        if (this.state.hasCause && dateValidation && (this.state.hasDate && !dateValidation.isFutureDate) && (this.state.hasTimeChanged && !dateValidation.isFutureTime) && this.state.name && this.state.contactValidation) {
            await this.props.dispatcSetFNOLDetails(this.state.causeOfCollision, this.state.startDate, this.props.claimSubmit.time, this.state.name, this.state.contact)
            var postData = JSON.stringify({
                CustomerId: this.props.profile.customerId,
                PolicyRiskItemId: this.props.claimSubmit.selectedRiskItem.id,
                IncidentEventType: this.state.causeOfCollision?.id,
                Date: this.props.claimSubmit.incidentDate,
                Time: this.props.claimSubmit.time,
            });
            var duplicateClaims = await this.props.dispatchAction(checkDuplicateClaimDrivable(postData));
            if (duplicateClaims) {
                await this.props.dispatchShowDuplicateClaim();
            } else {
                var contactPayload = { contactPersonFullName: this.state.name, contactPersonNumber: this.state.contact };
                await this.props.dispatchAction(setClaimData(contactPayload));

                await this.props.dispatchHandleNextStep();
                this.checkMobileRedirect();
            }
        } else {
            this.setState({ Step1Disabled: true })
        }
    }

    checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
        }
    }

    async handleIncidentToggle(e: any) {
        await this.setState({
            IncidentToggle: !this.state.IncidentToggle
        });
        window.scrollBy(0, 1);
    }

    async handleIndidentDateClicked() {
        this.setState({
            isClosed: false,
        })
        document.body.addEventListener("click", this.handleClickAway);
    }

    checkTimeToggle() {
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchSetTimeShow();
        }
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    async handleIncidentEventSelection(e: any) {
        let coverItem = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ causeOfCollision: coverItem[0], hasCause: true });
    }

    async setTime(f12: any, f24: any) {
        document.body.removeEventListener("click", this.handleClickAway);

        this.setState(prevState => {
            return {
                ...prevState,
                time12: f12, time24: f24,
                mouseOut: false,
                isClosed: true,
                hasTime: false, hasTimeChanged: true,
                hasFutureTime: false, hasFutureDate: false
            }
        }, (async () => {
            await this.props.dispatchSetTime(f12, f24)
            await this.props.dispatchSetTimeShow();
            if (this.state.Step1Submitted) {
                this.checkStep1Answers();
            }
        }).bind(this));
    }

    async handleIsStationary(isStationary) {
        await this.props.dispatchSetIsStationary(isStationary);
        await postToController(this.props.dispatch, 'GetIncidentTypesByIncidentEventTypeId', JSON.stringify(
            {
                EventTypeId: this.props.claimSubmit.incidentType.id,
                IsStationary: (isStationary == 'yes'),
                IsMotorbike: (this.props.claimSubmit.selectedRiskItem.productName == 'Motorbike')
            })).then(async (response) => {
                await this.props.dispatchSetIncidentEventList(response, this.props.claimSubmit.incidentType);
                return true;
            })
        await this.setState({ causeOfCollision: "", hasCause: false });
    }

    public render() {
        let incidentEventTypes = <div></div>;
        if (this.props.claimSubmit.incidentEventList) {
            incidentEventTypes = this.props.claimSubmit.incidentEventList.map((event) => {
                return <>
                    <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                        {event.description}
                    </Dropdown.Item>
                    <div className="ssp-hr-container">
                        <hr className="cover-divider" />
                    </div>
                </>
            });
        }

        return (
            <div className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-claim-info">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src='/my-policy/Images/Claims/Numbers/1-red.png' alt="Step 1" title="Step 1" />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                {
                                    (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) &&
                                    <h3>Claim details</h3>
                                }
                                {
                                    (this.props.claimSubmit.claimType != CLAIM_TYPE_GLASS) &&
                                    <h3>Claim info</h3>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-form-section-holder">
                        <hr className="hr-minus21px" />
                        <p className="fnol-form-intro-p">
                            {
                                (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) &&
                                <>
                                    Please confirm your car's details below, you can edit the details that are incorrect
                                </>
                            }
                            {
                                (this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS) &&
                                <>
                                    Before we can look into your claim,&nbsp;
                                    <br className="mobile-br" />
                                    we need a few details
                                </>
                            }
                        </p>
                        <div className="ssp-form">
                            {
                                (this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS && this.props.ssp.drivableClaimsEnabled) &&
                                <div className="row noma glassclaims-parent-row ">
                                    <div className="col nopa">
                                        <p className="text-16 glassclaims-intro-p stationary-p"><b>Was someone {this.props.claimSubmit.selectedRiskItem.productName == 'Motorbike' ? 'riding or on the motorbike' : 'driving or in the car'} at the time of <br className="fnol-newline" />the incident</b></p>
                                    </div>
                                    <div className="nopa text-lg-right glassclaims-button-col">
                                        <div className="row noma glassclaims-button-row">
                                            <div className="col nopa glassclaims-button-no">
                                                <button className={this.props.claimSubmit.isStationary === 'yes' ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="stationary-yes" onClick={() => this.handleIsStationary('yes')}>No</button>
                                            </div>
                                            <div className="glassclaims-mobile-gutter nopa"></div>
                                            <div className="col nopa glassclaims-button-yes">
                                                <button className={this.props.claimSubmit.isStationary === 'no' ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="stationary-no" onClick={() => this.handleIsStationary('no')}>Yes</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {(this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS || !this.props.ssp.drivableClaimsEnabled || (this.props.claimSubmit.incidentEventList && this.props.claimSubmit.incidentEventList.length > 0)) &&
                                <>
                                    <div className="mb-0px mt-20px" />
                                    <div className={'form-group ' + (this.state.Step1Submitted && !this.state.hasCause ? ' has-error' : '')}>
                                        <Dropdown id="CollisionCause-fnol" className="ssp-dropdown ssp-dropdown-item-list-no-images"
                                            onSelect={this.handleIncidentEventSelection}
                                            onToggle={this.handleCoverDropdownToggle}>
                                            <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button">
                                                {this.state.hasCause &&
                                                    <>
                                                        <div className="row ssp-dropdown-select-row">
                                                            <div className="col">
                                                                <span className="ssp-dropdown-select-choose-text-selected-product">Cause of {this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS ? 'damage' : 'collision'}</span>
                                                                <span className="ssp-dropdown-select-selected-product" id="selectedCollision">{this.state.causeOfCollision.description}</span>
                                                            </div>
                                                            <div className="ssp-dropdown-icon"></div>
                                                        </div>
                                                    </>
                                                }
                                                {!this.state.hasCause &&
                                                    <div className="row ssp-dropdown-select-row">
                                                        <div className="col ssp-dropdown-select-choose-text-no-product">
                                                            Cause of {this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS ? 'damage' : 'collision'}
                                                        </div>
                                                        <div className="ssp-dropdown-icon"></div>
                                                    </div>
                                                }
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                {incidentEventTypes}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        {this.state.Step1Submitted && !this.state.hasCause &&
                                            <div className="form-inline-error">Event type is required</div>
                                        }
                                    </div>
                                </>}
                        </div>
                    </div>
                    {(!this.props.ssp.drivableClaimsEnabled || (this.props.claimSubmit.incidentEventList && this.props.claimSubmit.incidentEventList.length > 0)) &&
                        <>
                            <div className="col-12 nopa ssp-form">
                                <div className={'form-group position-relative ' + ((this.state.Step1Submitted && !this.state.hasDate) || this.state.hasFutureDate ? 'has-error' : '')} onClick={this.checkTimeToggle}>
                                    <label className={'form-label ssp-calendar-label' + (this.state.startDate !== "" ? "" : " no-opacity")}>Incident date</label>
                                    <ModernDatepicker
                                        date={this.state.startDate}
                                        format={'DD-MM-YYYY'}
                                        showBorder
                                        onChange={(date) => this.handleChangeDateValue(date)}
                                        placeholder="Select incident date"
                                        maxDate={this.state.maxDate}
                                        id="FNOL-datepicker"
                                        className="ssp-calendar-input calendar-inline-icon"
                                    />
                                    {this.state.Step1Submitted && !this.state.hasDate &&
                                        <div className="form-inline-error">Date is required</div>
                                    }
                                    {this.state.Step1Submitted && this.state.hasFutureDate && this.state.hasDate &&
                                        <div className="form-inline-error">The date should not be in the future</div>
                                    }
                                </div>
                                {this.props.claimSubmit.timeDisplay &&
                                    <div className={'form-group position-relative ' + ((this.state.Step1Submitted && !this.state.hasTimeChanged) || this.state.hasFutureTime ? ' has-error' : '')} >
                                        {this.props.claimSubmit.timeDisplay &&
                                            <label className={'form-label' + (this.props.claimSubmit.timeDisplay ? "" : " no-opacity")}>Incident time</label>
                                        }
                                        <input type="button" className="form-control ssp-time-input text-left watch-inline-icon" value={this.props.claimSubmit.timeDisplay ? this.props.claimSubmit.timeDisplay : 'Select incident time'} disabled={this.props.isClosed} onClick={this.handleIndidentDateClicked} />
                                        <div className={this.props.claimSubmit.IsIncidentDateClicked ? 'visible w-100' : 'invisible'} onMouseLeave={this.setMouseOut} onMouseEnter={this.setMouseIn}>
                                            <TimeKeeper
                                                time={this.props.claimSubmit.timeDisplay}
                                                onChange={(newTime) => this.handleTimeChange(newTime.formatted12, newTime.formatted24)}
                                                doneButton={(newTime) => (
                                                    <div
                                                        className="btn btn-solid-red process"
                                                        onClick={() => this.setTime(newTime.formatted12, newTime.formatted24)}
                                                    >
                                                        Close
                                                    </div>
                                                )}
                                                switchToMinuteOnHourSelect
                                                closeOnMinuteSelect
                                            />
                                        </div>
                                        {this.state.Step1Submitted && !this.state.hasTimeChanged &&
                                            <div className="form-inline-error">Time is required</div>
                                        }

                                        {this.state.Step1Submitted && this.state.hasFutureTime && this.state.hasTimeChanged &&
                                            <div className="form-inline-error">The time should not be in the future</div>
                                        }
                                    </div>
                                }
                                <div className="fnol-form-group fnol-form-sub-header">
                                    <h4>Who should we chat to <br className="mobile-br" /> about this claim?</h4>
                                </div>
                                <div className={'form-group ' + (this.state.Step1Submitted && !this.state.name ? 'has-error' : '')}>
                                    <label className={'form-label' + (this.state.name !== "" ? "" : " no-opacity")}>Name</label>
                                    <input placeholder="Name" className={"form-control " + (this.state.Step1Submitted && !this.state.name ? 'form-control-error' : "underline")} id="info-contact-name" name="name" value={this.state.name} onChange={this.handleChangeStep1} />
                                    {this.state.Step1Submitted && !this.state.name &&
                                        <div className="form-inline-error">Name is required</div>
                                    }
                                </div>
                            <div className={'form-group noma ' + (this.state.Step1Submitted && (!this.state.contactValidation || !this.state.contact) ? 'has-error' : '')}>
                                    <label className={'form-label' + (this.state.contact !== "" ? "" : " no-opacity")}>Phone no.</label>
                                    <input type="text" placeholder="Phone number" className={"form-control " + (this.state.Step1Submitted && !this.state.contact ? 'form-control-error' : "info-underline")} id="contact-number" name="contact" value={this.state.contact} onChange={this.handleChangeStep1} />
                                {this.state.Step1Submitted && !this.state.contact &&
                                        <div className="form-inline-error">Contact details are required</div>
                                }
                                {this.state.Step1Submitted && !this.state.contactValidation &&
                                    <div className="form-inline-error">Contact details are incorrect</div>
                                }
                                </div>
                            </div></>}

                    <div className="col-12 nopa fnol-where-it-happened-buttonholder">
                        <button className="btn btn-solid-red fnol-where-it-happened-button-next" id="btn-info-next" disabled={this.state.Step1Disabled} onClick={this.handleStep1Submit}>Next</button>
                        <button className="btn btn-outline-red fnol-where-it-happened-button-back" id="btn-info-back" onClick={this.handleStepBack}>Back</button>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        dipatchCompleteStep: () => dispatch(completeStep()),
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSetDate: (data) => dispatch(setDate(data)),
        dispatchSetTime: (time12, time24) => dispatch(setTime(time12, time24)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatcSetFNOLDetails: (IncidentEventType, IncidentDate, IncidentTime, ContactName, ContactNumber) => dispatch(setFNOLDetails(IncidentEventType, IncidentDate, IncidentTime, ContactName, ContactNumber)),
        dispatchShowDuplicateClaim: () => dispatch(showDuplicateClaim()),
        dispatchSetIsStationary: (data) => dispatch(setStationary(data)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetIncidentEventList: (list, event) => dispatch(setFnolIncidentEventList(list, event)),
        dispatchAction: (e) => dispatch(e)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep1Sub4)